import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.prototype.uploadImageUrl = '/manage/upload' // 图片上传地址
Vue.prototype.pageLayout = 'total, sizes, prev, pager, next, jumper' // 分页-layout
Vue.prototype.pagePageSizes = [10, 15, 20, 30] // 分页-page-sizes
Vue.prototype.pagePageSize = 10 // 分页-page-size

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
	if (to.path != '/login' && !store.state.hasLogin) {
		// auto login
		let data = localStorage.getItem('login')
		if (data) {
			store.dispatch('setLogin', JSON.parse(data))
		} else {
			next({path: '/login'})
		}
	}
	next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
